import React from 'react';

import Paper from 'material-ui/Paper';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';

import RaisedButton from 'material-ui/RaisedButton';
import PropTypes from "prop-types";
import CircularProgress from 'material-ui/CircularProgress';
import Dialog from 'material-ui/Dialog';
import {fullBlack} from "material-ui/styles/colors";
import ActionLeft from 'material-ui/svg-icons/av/replay';

const style = {
    marginLeft: 60,
    marginTop: 100,
    marginBottom: 100
};

export default class Downloader extends React.Component {
    constructor(props) {
        super(props);

        this.idown = null;

        this.state = {
            message: false,
            inProgress: false
        };

        this.startDownload = this.startDownload.bind(this);
    }

    startDownload(postFixUrl) {
        const self = this;
        this.setState({
            message: false,
            inProgress: true
        });

        this.ajax_download(postFixUrl);

        setTimeout(function () {
            self.idown = false;

            self.setState({
                message: false,
                inProgress: false
            });
        }, 8000);
    }

    render() {
        return (<div><Paper>
                {this.getControlBtns()}
                {!this.state.inProgress && <RaisedButton style={style} label="Download ALL products" primary onClick={this.startDownload.bind(this, 'all')}/>}
                {!this.state.inProgress && <RaisedButton style={style} label="Download only changed recently" secondary onClick={this.startDownload.bind(this, 'latest')}/>}
                <div id="download_iframe" />
                {this.state.inProgress &&  <CircularProgress size={80} thickness={5} />}
                {this.state.inProgress &&  <div style={style}><h1>We are preparing your CSV file....</h1></div>}
            </Paper>
                <Dialog
                    title="Server error... :("
                    modal={true}
                    open={this.state.message}
                >
                    {this.state.message}
                </Dialog>
            </div>);
    }

    getControlBtns() {
        return (
            <Toolbar>
                <ToolbarGroup firstChild={true}>
                </ToolbarGroup>
                <ToolbarGroup>
                    <ToolbarTitle text="Get file" />
                    <ToolbarSeparator />

                    <RaisedButton
                        icon={<ActionLeft color={fullBlack} />}
                        onClick={this.props.handlePrev}
                    />

                </ToolbarGroup>

            </Toolbar>)
        ;
    }

    ajax_download(postFixUrl) {
        const self = this;
        const seller_id = this.props.seller_id;
        const iframeContentUrl = `/api/seller/${seller_id}/csv/download/` + (postFixUrl === "all" ? "all" : "latest");

        const iframeId = 'idown' + Math.random();

        if (!this.idown) {
            this.idown = document.createElement('<iframe>', { id: iframeId, src:iframeContentUrl });
            this.idown.style.display = 'none';
            document.body.appendChild(this.idown);
        }

        const httpRequest = new XMLHttpRequest();

        httpRequest.onreadystatechange = function() {
            if (httpRequest.readyState === 4) {
                if (httpRequest.status === 200) {
                    //
                } else {
                    self.setState({
                        message: httpRequest.code + ' ' + httpRequest.responseText
                    });
                }
            }
        };
        httpRequest.open('GET', iframeContentUrl);
        httpRequest.send();

    }
}


Downloader.propTypes = {
    seller_id: PropTypes.number.isRequired,
    handlePrev: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./assets/src/js/Downloader.jsx